export default __webpack_public_path__ + "static/media/030-toxic.09ccde19.svg";